import React, { useState } from "react";
import ModalForm from "../../../../components/modalComponents/ModalForm";
import InputText from "../../../../components/modalComponents/InputText";
import InputSelect from "../../../../components/modalComponents/InputSelect";
import InputDate from "../../../../components/modalComponents/InputDate";
import InputUploadFile from "../../../../components/modalComponents/InputUploadFile";
import { usePropsInputs } from "../../../../hooks/useProps/usePropsInput";
import { usePropsSelect } from "../../../../hooks/useProps/usePropsSelect";
import { crearCampanaBeneficiosAPI, crearCampanaBonoTutoriaAPI } from "../../../../consumers/backendApisUrls";
import { useSubmitForm } from "../../../../hooks/useSubmitForm/useSubmitForm";
import BaseCampanaBonoTutoria from "./BaseCampanaBonoTutoria";
import { toast } from "react-toastify";

const CrearCampanaBonoTutoria = ({ toggleModal, refreshPage }) => {
  const SECTION_NAME = "CrearCampanaBonoTutoria";
  const KEYS = {
    NombreCampana: "NombreCampana",
    FechaInicioCampana: "FechaInicioCampana",
    FechaFinCampana: "FechaFinCampana",
    FechaInicioTutoria: "FechaInicioTutoria",
    FechaFinTutoria: "FechaFinTutoria",
    LineamientoFile: "LineamientoFile",
    IdEmpleado: "IdEmpleado",
    FechaTutorInicio: "FechaTutorInicio",
    FechaTutorFin: "FechaTutorFin",
    EstadoRegistro: "EstadoRegistro",
    MontoProporcional: "MontoProporcional",
    CargaExcel: "CargaExcel"
  };
  const [formValues, setFormValues] = useState({});
  const [allDropdowns, setAllDropdowns] = useState([]);
  const [filas, setFilas] = useState([]);
  const [commonProps] = usePropsInputs(formValues, setFormValues, SECTION_NAME);
  const [selectProps] = usePropsSelect(allDropdowns, formValues, setFormValues, SECTION_NAME);
  const [isLoading, setIsLoading] = useState(true);
  const [isUploading, setIsUploading] = useState(false);
  const [submitForm] = useSubmitForm();
  const [paginator, setPaginator] = useState({ CurrentPage: 1 });
  const [registrosDuplicados, setRegistrosDuplicados] = useState([]);
  const [registrosErrados, setRegistrosErrados] = useState([]);
  const [showAlert, setShowAlert] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const api = crearCampanaBonoTutoriaAPI();
    const payload = getPayload();
    try {
      await submitForm(
        Object.values(KEYS),
        api,
        payload,
        SECTION_NAME,
        res => successSubmit(res.data)
      );
    } catch (error) {
      console.log("hubo un error")
            toast.success(error);
    } finally {
      setIsLoading(false);
    }
  };

  const getPayload = () => {
    const filasPayload = filas.map((row) => {
      return {
        IdEmpleado: row.IdEmpleado,
        FechaTutorInicio: row.FechaTutorInicio,
        FechaTutorFin: row.FechaTutorFin,
        EstadoRegistro: row.EstadoRegistro,
      };
    });
    return {
      ...formValues,
      ListaSolicitudBonoTutoria: filasPayload
    };
  }

  const successSubmit = async (data) => {
    const hasErrors =
      (data.Data.RegistrosDuplicados && data.Data.RegistrosDuplicados.length > 0) ||
      (data.Data.RegistrosErrados && data.Data.RegistrosErrados.length > 0);

    setRegistrosDuplicados(data.Data.RegistrosDuplicados || []);
    setRegistrosErrados(data.Data.RegistrosErrados || []);

    if (hasErrors) {
      setShowAlert(true);
      return;
    }
    toggleModal();
    await refreshPage();
  };
  const handleCloseAlert = async () => {
    setShowAlert(false);
    toggleModal();
    await refreshPage();
  };
  return (
    <BaseCampanaBonoTutoria
      title="Crear nueva campaña"
      toggleModal={toggleModal}
      handleSubmit={handleSubmit}
      puedeEditar={true}
      sectionName={SECTION_NAME}
      filas={filas}
      setFilas={setFilas}
      allDropdowns={allDropdowns}
      setAllDropdowns={setAllDropdowns}
      formValues={formValues}
      setFormValues={setFormValues}
      commonProps={commonProps}
      selectProps={selectProps}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      isUploading={isUploading}
      setIsUploading={setIsUploading}
      KEYS={KEYS}
      paginator={paginator}
      setPaginator={setPaginator}
      nuevo={true}
      registrosDuplicados={registrosDuplicados}
      registrosErrados={registrosErrados}
      showAlert={showAlert}
      handleCloseAlert={handleCloseAlert}
    />
  );
}
export default CrearCampanaBonoTutoria;